"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExcludedSystemURLString = exports.getDataExportURLString = exports.getProjectExportSettings = exports.saveProjectExportSettings = exports.formatPanelSettings = exports.getDynataExtId = exports.validateLanguage = exports.getInitialProjectInfo = void 0;
var countries_1 = require("../countries");
var _ = require("lodash");
var axios_1 = require("axios");
var getInitialProjectInfo = function () {
    return {
        id: 0,
        avatarImage: '',
        botSpeed: '',
        botTheme: '',
        clientID: 0,
        devices: [],
        faviconImage: '',
        name: '',
        pageTitle: '',
        redirectURLs: {
            1: 'https://www.nexxt.in/',
            2: 'https://www.nexxt.in/',
            3: 'https://www.nexxt.in/',
            4: 'https://www.nexxt.in/'
        },
        sessionTimeout: 0,
        showProgress: true
    };
};
exports.getInitialProjectInfo = getInitialProjectInfo;
/**
 * Validate language - country set with dynata country - language list
 * The selected languages should be matching with at least one language from the dynata list
 * If the target language is speicified, check whether the project languages contains the targeted language.
 */
function validateLanguage(project, targetLanguage) {
    var _a;
    var selectedCountry = (_a = project === null || project === void 0 ? void 0 : project.countries) === null || _a === void 0 ? void 0 : _a[0];
    var selectedLanguages = project.languages;
    var isValid = false;
    if (!selectedCountry) {
        return true;
    }
    // For Kantar Greek
    if (selectedCountry.value === 'GR') {
        return true;
    }
    var countryInfo = countries_1.COUNTRY_LANGUAGE_LIST.find(function (country) { return country.id === selectedCountry.value; });
    if (!countryInfo) {
        // unsupported country
        return isValid;
    }
    selectedLanguages.forEach(function (language) {
        var languageSupport = countryInfo.supportedLanguages.find(function (supportedLanguage) { return supportedLanguage.id === language.value; });
        if (languageSupport) {
            isValid = true;
        }
    });
    if (targetLanguage &&
        !selectedLanguages.find(function (l) { return l.value === targetLanguage; })) {
        isValid = false;
    }
    return isValid;
}
exports.validateLanguage = validateLanguage;
// DYNATA_KEY_PREFIX
var getDynataExtId = function (id, prefix) {
    if (prefix === void 0) { prefix = ''; }
    if (String(id) == '2997')
        return '5579cf9e-99c0-11ee-abd8-16e163a8dad8'; // hacky fix for project
    try {
        if (prefix) {
            return "".concat(prefix, "-").concat(id);
        }
        return "".concat(id);
    }
    catch (err) {
        return "".concat(id);
    }
};
exports.getDynataExtId = getDynataExtId;
/**
 * @BACKWARD_COMPATIBILITY
 * To support multiple identifier sources in each panel
 * */
var formatPanelSettings = function (panelSettings) {
    var _a;
    try {
        var newPanel = (_a = panelSettings === null || panelSettings === void 0 ? void 0 : panelSettings.panels) === null || _a === void 0 ? void 0 : _a.map(function (panel) {
            if (_.hasIn(panel, 'identifierParamKey') &&
                !_.hasIn(panel, 'identifierKeys')) {
                return __assign(__assign({}, panel), { identifierKeys: [
                        {
                            identifierParamKey: (panel === null || panel === void 0 ? void 0 : panel.identifierParamKey) || '',
                            redirectIdentifierParamKey: (panel === null || panel === void 0 ? void 0 : panel.redirectIdentifierParamKey) || ''
                        }
                    ] });
            }
            return panel;
        });
        return __assign(__assign({}, panelSettings), { panels: newPanel });
    }
    catch (err) {
        return panelSettings;
    }
};
exports.formatPanelSettings = formatPanelSettings;
function saveProjectExportSettings(cssToken, baseUrl, projectId, exportSettings) {
    return __awaiter(this, void 0, void 0, function () {
        var DATA_API_URL, body, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    DATA_API_URL = "".concat(baseUrl, "/session/save");
                    body = {
                        sessionKey: projectId,
                        sessionContext: 'dashPortalSettings',
                        sessionObject: exportSettings
                    };
                    return [4 /*yield*/, axios_1.default.post(DATA_API_URL, body, {
                            headers: { Authorization: "Bearer ".concat(cssToken) },
                            withCredentials: true
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    err_1 = _a.sent();
                    console.log('Error - saveProjectExportSettings', err_1);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.saveProjectExportSettings = saveProjectExportSettings;
function getProjectExportSettings(cssToken, baseUrl, projectId) {
    return __awaiter(this, void 0, void 0, function () {
        var DATA_API_URL, res, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    DATA_API_URL = "".concat(baseUrl, "/session/load/dashPortalSettings/").concat(projectId);
                    return [4 /*yield*/, axios_1.default.get(DATA_API_URL, {
                            headers: { Authorization: "Bearer ".concat(cssToken) },
                            withCredentials: true
                        })];
                case 1:
                    res = _a.sent();
                    if (res === null || res === void 0 ? void 0 : res.data)
                        return [2 /*return*/, res.data];
                    return [2 /*return*/, {}];
                case 2:
                    err_2 = _a.sent();
                    console.log('Error - getProjectExportSettings', err_2);
                    return [2 /*return*/, {}];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getProjectExportSettings = getProjectExportSettings;
function getDataExportURLString(dataExportSettings) {
    try {
        var queryParams = '';
        if (dataExportSettings) {
            for (var _i = 0, _a = Object.entries(dataExportSettings); _i < _a.length; _i++) {
                var _b = _a[_i], exportOption = _b[0], selected = _b[1];
                if (selected) {
                    var queryParam = exportOption;
                    if (queryParams == '') {
                        queryParams += "".concat(queryParam);
                    }
                    else {
                        queryParams += "&".concat(queryParam);
                    }
                }
            }
        }
        return queryParams;
    }
    catch (err) {
        return '';
    }
}
exports.getDataExportURLString = getDataExportURLString;
function getExcludedSystemURLString(excludedSystemOptions) {
    try {
        var systemString = '';
        if (excludedSystemOptions && (excludedSystemOptions === null || excludedSystemOptions === void 0 ? void 0 : excludedSystemOptions.length) > 0) {
            var excludedSystemOptionsURL = excludedSystemOptions.reduce(function (url, option) { return url + "&system=".concat(option); }, '');
            systemString += excludedSystemOptionsURL;
        }
        return systemString;
    }
    catch (err) {
        return '';
    }
}
exports.getExcludedSystemURLString = getExcludedSystemURLString;
//# sourceMappingURL=project.js.map